"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var BackArrowIcon_1 = __importDefault(require("../../../common/Icons/BackArrowIcon"));
var EditIcon_1 = __importDefault(require("../../../common/Icons/EditIcon"));
var ThreeDButton_1 = __importDefault(require("../ThreeDButton"));
var product_1 = require("../../ducks/product");
var withErrorBoundary_1 = __importDefault(require("../../../../decorators/withErrorBoundary"));
var navigation_module_scss_1 = __importDefault(require("./navigation.module.scss"));
var styled_components_1 = __importDefault(require("styled-components"));
var ShareIcon_1 = __importDefault(require("../../../../icons/ShareIcon"));
var GenericMessage_1 = __importDefault(require("../../../common/GenericMessage"));
var ProductFavorite_1 = require("../../../common/ProductFavorite");
var Navigation = function (props) {
    var editPath = props.editPath;
    var _a = (0, react_redux_1.useSelector)(product_1.productSelector), _b = _a.permalink, permalink = _b === void 0 ? '' : _b, product = __rest(_a, ["permalink"]);
    var _c = (0, react_1.useState)(undefined), status = _c[0], setStatus = _c[1];
    var _d = (0, react_1.useState)(false), message = _d[0], setMessage = _d[1];
    var _e = (0, react_1.useState)(''), messageText = _e[0], setMessageText = _e[1];
    (0, react_1.useEffect)(function () {
        message && setTimeout(function () { return setMessage(false); }, 3000);
    }, [message]);
    return (react_1.default.createElement("div", { className: navigation_module_scss_1.default.root },
        react_1.default.createElement(IconButton, { className: navigation_module_scss_1.default.back, onClick: props.goBack },
            react_1.default.createElement(BackArrowIcon_1.default, null)),
        react_1.default.createElement("div", null,
            react_1.default.createElement(ThreeDButton_1.default, null),
            react_1.default.createElement(IconButton, { className: navigation_module_scss_1.default.edit, onClick: function () {
                    window.location.href = editPath;
                } },
                react_1.default.createElement(EditIcon_1.default, { className: navigation_module_scss_1.default.checcIcon })),
            react_1.default.createElement(ProductFavorite_1.ProductFavorite, { product: product, alwaysVisible: true, big: true }),
            react_1.default.createElement(IconButton, { className: navigation_module_scss_1.default.edit, onClick: function () {
                    'share' in navigator
                        ? navigator.share({ url: permalink })
                        : Promise.reject()
                            .catch(function () {
                            return navigator.clipboard
                                ? navigator.clipboard
                                    .writeText(permalink)
                                    .then(function () { return true; })
                                : Promise.reject();
                        })
                            .then(function (fromClipboard) {
                            if (!fromClipboard)
                                return;
                            setMessage(true);
                            setMessageText('Ссылка скопирована в буфер обмена');
                            setStatus('success');
                        })
                            .catch(function () {
                            setMessage(true);
                            setMessageText('Не удалось скопировать ссылку');
                            setStatus('error');
                        });
                } },
                react_1.default.createElement(ShareIcon_1.default, { className: navigation_module_scss_1.default.checcIcon }))),
        react_1.default.createElement(GenericMessage_1.default, { status: status, open: message, text: messageText })));
};
var mapStateToProps = function (state) { return ({
    editPath: (0, product_1.editPathSelector)(state),
}); };
var IconButton = styled_components_1.default.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 12px;\n  height: 48px;\n  border: none;\n  border-radius: 50%;\n  background-color: transparent;\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.08);\n  }\n  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n"], ["\n  padding: 12px;\n  height: 48px;\n  border: none;\n  border-radius: 50%;\n  background-color: transparent;\n  &:hover {\n    background-color: rgba(0, 0, 0, 0.08);\n  }\n  transition: background-color 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n"])));
exports.default = (0, react_redux_1.connect)(mapStateToProps, {
    goBack: product_1.goBack,
})((0, withErrorBoundary_1.default)(Navigation));
var templateObject_1;
